export default __webpack_public_path__ + "static/media/appveyor.ce3d6804.svg";